<template>
  <div>
  <!-- <vue-scroll class="card-base card-shadow--medium mb-30" style="height:400px"> -->
    <div class="p-20 flex">
      <div class="box">
        <h4 v-if="title" class="mv-0">{{title}}</h4>
        <h4 v-else class="mv-0">{{$('dashboards.sales-order-dashboard')}}</h4>
      </div>
      <div class="box center"></div>
      <div class="box dashboard-actions">
        <el-tooltip :content="$t('common.Refresh')" placement="top">
          <el-button :icon="loadingIcon" size="small" class="dashboard-action-btn" @click="refresh"></el-button>
        </el-tooltip>
        <el-tooltip v-if="id!=null" :content="$t('common.Configure')" placement="top">
          <el-button icon="el-icon-edit-outline" size="small" class="dashboard-action-btn" @click="handleConfigure"></el-button>
        </el-tooltip>
        <el-tooltip v-if="id!=null" :content="$t('common.Delete')" placement="top">
          <el-button icon="el-icon-delete" type="danger" plain size="small" class="dashboard-action-btn" @click="handleDelete"></el-button>
        </el-tooltip>
      </div>
    </div>
    <el-skeleton :count="1" animated :loading="loading">
      <template slot="template">
        <tableSkeleton :rows="parseInt((height-250)/40) || 1" :height="height-250" :columnLabel="[{ label:' ', width:50, sortable:false}, {label: 'Numéro', width:150, sortable:true}, {label: 'Client', sortable:true}, { label: 'Date',width: 100, sortable:true}, {label: 'Date de livraison', width: 100, sortable:true}, {label: 'Type de livraison', sortable:true}, {label: 'Statut', sortable:true}, {label: 'Étiquettes', sortable:false}]"></tableSkeleton>
      </template>
      <template>
        <salesOrderTable class="mb-20" :salesOrders="salesOrders" :customerId="customerId" :showDeliveryDate="showDeliveryDate" :height="height-250" :sort-prop="currentTableSortProp" :sort-order="currentSortOrder" @sort-change="handleSortChange"></salesOrderTable>
      </template>
    </el-skeleton>
    <div class="m-20 flex justify-space-between" style="display:absolute; top:20px;">
      <h4 class="mt-5 mb-0 o-050 fs-14 secondray-text">{{count}} {{$t('sales_orders.Sales-orders-displayed')}} {{totalCount}}</h4>
      <Pagination
        class="mt-5 mb-0 fs-14 secondary-text"
        :current-page="page"
        :total-number-of-page="totalPages"
        @click-previous="clickPrevious"
        @click-next="clickNext" />
    </div>
  </div>
  <!-- </vue-scroll> -->
</template>
<script>
import salesOrderTable from './sales-order-table'
import salesOrderAPI from '@/services/API/sales-order';
import moment from 'moment-timezone'
import tableSkeleton from '@/components/skeleton/table-skeleton'
import Pagination from '@/components/pagination.vue';
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'sales-order-dashboard-card',
	props: {
    uuid: {
      type: String
    },
    id : {
      type : Number
    },
    dashboard: {
      type: Object,
      default: null
    },
    position : {
      type : Number,
      required: true
    },
    showDeliveryDate : {
      type : Boolean,
      default : false
    },
    repFilters : {
      type : Boolean,
      default : true
    },
    customerId : null,
    filters : {
      type : Object
    },
    limit : {
      type : String,
      default : null
    },
    defaultType : {
      type : String,
      default : null
    },
    salesReps : {
      type : Array
    },
    title : {
      type : String,
      default : null
    },
    criterias : {
      type : Array
    },
    customerClasses : {
      type : Array
    },
    inventories: {
      type : Array
    },
    productId : {
      type : Number
    },
    height: {
      type: Number
    }
	},
  data() {
    return {
      salesOrders : [],
      type : 'CONFIRMED',
      loading : false,
      user : null,
      timer : '',
      totalCount : null,
      page: 1,
      totalPages : null,
      currentOrderBy: 'date',
      currentDirection: 'ASC',
    };
  },components: {
    salesOrderTable,
    tableSkeleton,
    Pagination
  },
  watch : {
    type : function(newVal, oldVal){
      if(newVal!=oldVal){
        this.fetchSalesOrders();
      }
    }
  },
	methods: {
    handleConfigure () {
      this.$emit('configure', this.dashboard);
    },
    handleDelete(){
      this.deleteDashboard(this.id)
        .then(()=>{
          this.$message({
          message: 'Le canal a été supprimé avec succès.',
          type: 'success'
        });
        })
    },
    clickPrevious () {
      if (this.page > 1) {
          this.page -= 1;
      }
      this.refresh();
    },
    clickNext () {
      if (this.page < this.totalPages) {
        this.page += 1;
        this.refresh();
      }
    },
    handleSortChange ({ prop, order }) {
      if (prop == null) return;

      const orderMap = {
        soNumber: 'so_number',
        'customer.usual_name': 'customer.name',
        'rep.name': 'sales_rep.first_name',
        date: 'date',
        expectedDeliveryDate: 'expected_delivery_date',
        delivery_type: 'delivery_type.code',
        'status.code': 'status.code',
      };

      if (order == null) {
        this.currentOrderBy = 'date';
        this.currentDirection = 'ASC';
      } else {
        this.currentOrderBy = orderMap[prop] || 'date';
        this.currentDirection = order === 'descending' ? 'DESC' : 'ASC';
      }

      this.page = 1;
      this.refresh();
    },
    refresh () {
      this.cancelAutoUpdate();
      this.fetchSalesOrders()
        .then(() => this.createTimer());
    },
    fetchSalesOrders(){
      this.loading =true;
      let params = {};

      params.statusCode = [];
      _.forEach(this.filters, (value, key)=>{
        if(value)params.statusCode.push(key);
      });

      params.reps = this.salesReps?this.salesReps:undefined;

      if(this.criterias!=null){
        _.forEach(this.criterias, criteria=>{
          if(criteria.field==='Date'){
            if(criteria.selectedOperator==='='){
              params.date=moment().format('YYYY-MM-DD Z');
            }else if(criteria.selectedOperator==='>='){
              params.startDate=moment().format('YYYY-MM-DD Z');
            }else if(criteria.selectedOperator==='>'){
              params.startDate=moment().add(1,'day').format('YYYY-MM-DD Z');
            }else if(criteria.selectedOperator==='<'){
              params.endDate=moment().subtract(1,'day').format('YYYY-MM-DD Z');
            }else if(criteria.selectedOperator==='<='){
              params.endDate=moment().format('YYYY-MM-DD Z');
            }
          }
        })
      }

      if (!_.isEmpty(this.inventories)) {
        params.inventoryId = _.map(this.inventories, inv => inv.id);
      }
      params.customerClassId = this.customerClasses ? this.customerClasses : undefined;
      params.productId = this.productId ? this.productId : undefined;

      if(this.customerId)params.customerId=this.customerId;
      // params.paging='no';
      params.limit = 50;
      params.page = this.page;
      params.orderBy=this.currentOrderBy;
      params.direction=this.currentDirection;



      return salesOrderAPI.fetchSalesOrders(params, ['customer'])
        .then(salesOrders=>{
          this.salesOrders = salesOrders.list;
          this.totalCount = salesOrders.count;
          this.totalPages = salesOrders.pages;
          this.updateTotalElement({ uuid: this.uuid, totalElement: this.totalCount});
          this.loading=false;
        })

    },
    _moment(datetime, format='LL'){
      return moment(datetime).format(format);

    },
    date(so){
      if(this.filters){
        let status = _.find(so.status_logs, status=>{return status.code==this.type});
        if(status==null)return false;
        return status.status_log.created_at;
      }else{
        return so.date;
      }

    },
    isConfirmed(so){
      return so.status.code=="CONFIRMED";
    },
    isVoided(so){
      return so.status.code=="VOIDED";
    },
    isActive(so){
      if(this.type=="SET_ASIDE"){
        let status = _.find(so.status_logs, status=>{return status.code==this.type});
        if(status==null)return false;
        var current = moment().startOf('day');
        var statusDate = moment(status.status_log.created_at).startOf('day');
        var duration = moment.duration(statusDate.diff(current)).asDays();
        return duration >= -19;
      }
      return false;
    },isIntermediary(so){
      if(this.type=="SET_ASIDE"){
        let status = _.find(so.status_logs, status=>{return status.code==this.type});
        if(status==null)return false;
        var current = moment().startOf('day');
        var statusDate = moment(status.status_log.created_at).startOf('day');
        var duration = moment.duration(statusDate.diff(current)).asDays();
        return duration < -19;
      }
      return false;
    },
    setSalesRepId(userId){
      this.fetchSalesOrders();
    },
    openSalesOrder(salesOrderId){
      var index='/sales-orders/'+salesOrderId;
      this.$router.push(index);
    },
    openCustomer(customerId){
      var index='/customers/'+customerId;
      this.$router.push(index);
    },
    createTimer () {
      this.timer = setInterval(this.fetchSalesOrders, 60000 + (this.position * 2000));
    },
    cancelAutoUpdate () { clearInterval(this.timer) },
    ...mapActions('users',['fetchAdminUsers']),
    ...mapActions('genericDashboards', ['updateTotalElement', 'deleteDashboard']),
	},
	computed: {
    currentSortOrder() {
      return this.currentDirection === 'DESC' ? 'descending' : 'ascending';
    },
    currentTableSortProp() {
      const reverseOrderMap = {
        so_number: 'soNumber',
        'customer.name': 'customer.usual_name',
        'sales_rep.first_name': 'rep.name',
        date: 'date',
        expected_delivery_date: 'expectedDeliveryDate',
        'delivery_type.code': 'delivery_type',
        'status.code': 'status.code',
      };
      return reverseOrderMap[this.currentOrderBy] || 'date';
    },
    loadingIcon(){
      if(this.loading)return 'el-icon-loading'
      else return 'el-icon-refresh'
    },
    count(){
      if(this.salesOrders==null)return 0;
      else return this.salesOrders.length;

    },
    ...mapGetters('users', [ 'filterUserWithRoleRep']),
	},
  created(){
    if(this.defaultType!=null){
      this.type = this.defaultType;
    }

    this.fetchSalesOrders()
      .then(() => this.createTimer())

    this.fetchAdminUsers();
  },
  beforeDestroy () {
    this.cancelAutoUpdate();
  }
}
</script>
<style lang="scss" scoped>

.dashboard-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dashboard-action-btn {
  width: 32px;
  height: 32px;
  padding: 0;
  border-radius: 8px;
}




</style>
